import type { PatternMetadata } from '@takeshape/schema';
import { createReducer } from 'typesafe-actions';
import { IMPORT_STATUS } from '../common/types.js';
import { type Action, fetchPatternMetadata, setError, setImportStatus, setRepo } from './actions.js';

export const initialState = {
  loading: true,
  error: null,
  patternMetadata: {},
  importStatus: IMPORT_STATUS.NOT_STARTED,
  repo: null
};

export type AddToTakeShapeState = {
  loading: boolean;
  error: string | null;
  patternMetadata: PatternMetadata;
  importStatus: IMPORT_STATUS;
  repo: string | null;
};

export default createReducer<AddToTakeShapeState, Action>(initialState)
  .handleAction(fetchPatternMetadata.requested, (state) => ({
    ...state,
    loading: true,
    error: null
  }))
  .handleAction(fetchPatternMetadata.fulfilled, (state, action) => ({
    ...state,
    loading: false,
    patternMetadata: action.payload.patternMetadata
  }))
  .handleAction(setError, (state, action) => ({
    ...state,
    error: action.payload
  }))
  .handleAction(setImportStatus, (state, action) => ({
    ...state,
    importStatus: action.payload
  }))
  .handleAction(setRepo, (state, action) => ({
    ...state,
    repo: action.payload
  }));
